import axios, { getVariable } from "./api";

export const findCategoryActives = async () => {
  return axios.get((await getVariable("CONHECIGAME_API")) + "/public/v1/categoria/ativas");
};
